import { json } from 'react-router-dom'
import Axois from '../utils/axios'
import EventEmitter from '../utils/eventEmitter';



export const loadDeferredExpenses = async () => {
  let response = await Axois.get('/deferred-expenses').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
    const responseData = await response.data;
    return responseData;
}


export const loadDeferredExpenseAndSetup = async (action) => {
  try {
    switch (action) {
      case 'new':
        let requests = await Axois.get('/setups/deferred-expense');
        const responseData = await requests.data;
        console.log(responseData)
        return {...responseData, deferred_expense: {}};
      
      default:
        let response = await Axois.get('/deferred-expenses/'+action);
        const responseJson = await response.data;
        return responseJson;
    }
  }catch (err) {
    console.log(err);
  }
}



const useDeferredExpenseAPI = () => {
  
  const saveDeferredExpense = async (data, success) => {
    try {
      const response = await Axois.post('/deferred-expenses', data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('save_deferred_expense_response', {status: 'draft', seo: data.seo});
    }catch(err) {
      console.log(err);
    }
  };

  const updateExpenseStatus = async (seo, status, success) => {
    try {
      const response = await Axois.patch('/deferred-expenses/'+seo, {status: status});
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('updateStatusExpenseResponse', {status: status});
    }catch (err) {
      console.log(err);
    }
  }

  const update = async (seo, data, success) => {
    try {
      const response = await Axois.put('/deferred-expenses/'+seo, data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('updateStatusExpenseResponse', {status: 'draft', seo: data.seo});
    }catch (err) {
      console.log(err);
    }
  }

  return { saveDeferredExpense, updateExpenseStatus, update };
}


export default useDeferredExpenseAPI;